<div role="alert" class="mb-20 fade">
    <!-- warn-page-alert  info-page-alert  error-page-alert   success-page-alert  -->
  <div class="flex align-center error-page-alert">
    <div class="icon-container">
      <div class="alert-icon">
        <!-- Success Icon -->
        <i class="fas fa-check"></i>
        <!-- Warn Icon -->
        <!-- <i class="fas fa-exclamation"></i> -->

        <!-- Error Icon -->
        <!-- <i class="fas fa-exclamation"></i> -->

        <!-- Info Icon -->
        <!-- <i class="fas fa-info"></i> -->
      </div>
    </div>
    <div class="plr-10 ptb-20">
      <h5 class="semibold">{{messageHeading}}</h5>
      <p class="alert-page-details">{{message()}}</p>
    </div>
  </div>
</div>
